import "src/PackagesSelection/PackagesSelection.css.ts.vanilla.css!=!../../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"src/PackagesSelection/PackagesSelection.css.ts.vanilla.css\",\"source\":\"#H4sIAAAAAAAAA7VV246bMBR8z1e4qirtqiVyCLmB1H8x2AY3BLPGbFCq/nuNjVkbSLqtuiBePJwzc65e3142kp4g+LkC4MqwLGKwgfBLsvq1Whtso7EaYcyqPEi5lPwSgzCqu8Q5l7yOAXTMQm12QSJnlY9s7yKRRlIuMBGBQJi1TQyOdac/aL6eNEXZORe8rXAMPlNKZ0K2oa/OVz3y7TRfxksulKNw378OvNewJJ0MpEBVQ7lQPtq6JiJDDUkWbG1cRsbRYzs8Zjt6eS4JlfMsC5YXC8dOzKO7051cJm+FzlCZPfXVBl9BpKDnxKlLMCW5k0P0sTx+QoNJkKlpJQUPVNtt3yaf2KXmQqJKGgedhXdKgwuOjrKhJzvPkfMDNmF6jQdpRsmfJBJ3tKIhMSnvgqZAmF/VuCnBke1xIPIUPcFv+l3vnh1HdCoxhHYcFpP/Lxy55iiIabODH0kxXRLLqWSmj3nDJOOqwIKUSLJX4vzyw5uEk34c+DzPtf3HdYzShpetJMlqsrreIghtKkxLRQY1s+UuntITtNdPYmcflSxXdBmpJBH9KeWVDBp2I4pwSHbJKhKMrENd+r60Z9Fwpm2v46Er4rK4bjJUM6kk3Lx9A+EBnTaOcfUXxrPVw7WxG9b+QVjzEEbXNSqJlGSNkTg7/uv/5X8szej65f07epYz4XV75A98M9Vs95Gn2V4083vgQaG34DvA7PXOynGuRoBayZXhbyDzXtamBwAA\"}!../../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"
export var body = 'zq1tf98';
export var button = 'zq1tf9h';
export var buttonContainer = 'zq1tf9g';
export var card = {'default':'zq1tf99',suggested:'zq1tf9a'};
export var cardContainer = 'zq1tf91';
export var cardMaxWidth = 'zq1tf9b';
export var cardMaxWidthMobile = 'zq1tf9c';
export var chosenCard = 'zq1tf9d';
export var container = 'zq1tf90';
export var debitCard = 'zq1tf9e';
export var debitCardMc = 'zq1tf9f';
export var featureGroupContainer = 'zq1tf9r';
export var featureGroupLabel = 'zq1tf9q';
export var featureIcon = {included:'zq1tf9m','not-included':'zq1tf9n'};
export var featureLabel = {included:'zq1tf9o','not-included':'zq1tf9p'};
export var header = 'zq1tf94';
export var headerBody = 'zq1tf96';
export var headerCaption = 'zq1tf97';
export var headerHeading = 'zq1tf95';
export var mobileTitleContainer = 'zq1tf93';
export var priceAdditionalInfo = 'zq1tf9s';
export var priceBeforeDiscountAmount = 'zq1tf9i';
export var priceBeforeDiscountAmountStrike = 'zq1tf9k';
export var priceBeforeDiscountLabel = 'zq1tf9j';
export var pricePeriodicity = 'zq1tf9l';
export var titleContainer = 'zq1tf92';